import { useMemo, useState } from "react";
import { ArrowUp, ArrowDown, ChevronsUpDown } from "lucide-react";
import { TableHead } from "./ui/table";

export function useSort(items, accessors) {
  const [sort, setSort] = useState({ key: null, dir: 1 });
  const toggle = (key) => setSort((s) => (s.key === key ? (s.dir === 1 ? { key, dir: -1 } : { key: null, dir: 1 }) : { key, dir: 1 }));
  const sorted = useMemo(() => {
    if (!sort.key || !accessors[sort.key]) return items;
    const acc = accessors[sort.key];
    return [...items].sort((a, b) => {
      const va = acc(a), vb = acc(b);
      if (va == null || va === "") return 1;
      if (vb == null || vb === "") return -1;
      if (typeof va === "number" && typeof vb === "number") return (va - vb) * sort.dir;
      return String(va).localeCompare(String(vb), "hr") * sort.dir;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, sort]);
  return { sorted, sort, toggle };
}

export const SortHead = ({ label, sortKey, sort, onToggle, className = "", align = "left", ...rest }) => (
  <TableHead
    {...rest}
    data-testid={`sort-${sortKey}`}
    onClick={() => onToggle(sortKey)}
    title="Klikni za sortiranje"
    className={`${className} cursor-pointer select-none hover:text-[#0D9488] transition-colors duration-150`}
  >
    <span className={`inline-flex items-center gap-1 ${align === "right" ? "flex-row-reverse" : ""}`}>
      {label}
      {sort.key === sortKey ? (
        sort.dir === 1 ? <ArrowUp className="w-3 h-3 text-[#0D9488]" /> : <ArrowDown className="w-3 h-3 text-[#0D9488]" />
      ) : (
        <ChevronsUpDown className="w-3 h-3 opacity-40" />
      )}
    </span>
  </TableHead>
);
